import { isUWPApp, isIOSApp, isAndroidApp } from '@/utils/browser';

declare global {
  interface External {
    notify: (message: string) => void;
  }
  interface Window {
    webkit?: any;
    Android?: any;
  }
}

export function notifyApp(type: string, data: string[] | null = null): void {
  const version = 1;
  const notifyMessage = { version, type, data };
  if (isUWPApp) {
    window.external.notify(JSON.stringify(notifyMessage));
  } else if (isIOSApp) {
    window.webkit?.messageHandlers?.callbackHandler?.postMessage(notifyMessage);
  } else if (isAndroidApp) {
    window.Android?.notifyApp(JSON.stringify(notifyMessage));
  }
}
